import { doc, getDoc, increment, serverTimestamp, setDoc, updateDoc } from 'firebase/firestore';
import { db } from './firebase';

const SESSION_KEY = 'typing-cannon.visit-recorded.v1';
const counterRef = doc(db, 'public_metrics', 'typing_cannon');

export async function recordVisit(): Promise<number | null> {
  try {
    if (!sessionStorage.getItem(SESSION_KEY)) {
      const current = await getDoc(counterRef);
      if (current.exists()) {
        await updateDoc(counterRef, { visits: increment(1), updatedAt: serverTimestamp() });
      } else {
        await setDoc(counterRef, { visits: 1, updatedAt: serverTimestamp() });
      }
      sessionStorage.setItem(SESSION_KEY, 'true');
    }
    const current = await getDoc(counterRef);
    const visits = current.data()?.visits;
    return typeof visits === 'number' && Number.isFinite(visits) ? visits : null;
  } catch {
    return null;
  }
}
